import { render } from "./AccountDetails.vue?vue&type=template&id=5112bfed&scoped=true&ts=true"
import script from "./AccountDetails.vue?vue&type=script&lang=ts"
export * from "./AccountDetails.vue?vue&type=script&lang=ts"

import "./AccountDetails.vue?vue&type=style&index=0&id=5112bfed&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5112bfed"]])

export default __exports__